interface Debounceable {
    __debounceTimeouts?: Record<PropertyKey, number>;
}

/**
 * Debounce decorator for class methods
 * @param wait The number of milliseconds to delay
 */
export function debounce(wait: number) {
    return function (value: Function, context: {kind: string; name: PropertyKey}) {
        if (context.kind === 'method') {
            return function (this: Debounceable, ...args: unknown[]) {
                if (this.__debounceTimeouts === undefined) {
                    this.__debounceTimeouts = {};
                }

                if (this.__debounceTimeouts[context.name]) {
                    clearTimeout(this.__debounceTimeouts[context.name]);
                }

                this.__debounceTimeouts[context.name] = setTimeout(() => {
                    value.call(this, ...args);
                }, wait);
            };
        }
    };
}
